import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { InputWithButtonEdit } from '@/pages/_base/inputs/InputWithButtonEdit';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_user_settings_update_name } from '@/state/user/settings/remote_user_settings_update_name';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

function InputUserName() {
  const dispatch = use_dispatch();

  const { user_full_name } = use_slice_user(['user_full_name']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const [value, set_value] = useState(user_full_name);

  const [value_default, set_value_default] = useState(user_full_name);

  /*
   * EFFECTS
   */

  use_effect(() => {
    set_value_default(user_full_name);
    set_value(user_full_name);
  }, [user_full_name]);

  /*
   * EVENTS
   */
  async function onChangeCommited(value_new: string) {
    const value_new_update = value_new.is_blank() ? user_full_name : value_new;
    onChange(value_new_update);

    if (value_new_update === user_full_name) return;

    set_value_default(value_new_update);

    await dispatch(remote_user_settings_update_name(value_new_update));
  }

  function onChange(value: string) {
    set_value(value);
  }

  /*
   * HTML
   */
  return (
    <div className="flex gap-3 items-center">
      <h3 className="flex w-[10rem]">{t(i18n_page_settings_user.tabs.account.general_component.input.user_name.label)}:</h3>

      <InputWithButtonEdit className="min-h-9 max-h-9 h-9" {...{ value_default, value, onChange, onChangeCommited }} use_value_default_for_blank={false} />
    </div>
  );
}

export default memo(InputUserName);
